<template>
  <div class="main-container">
  <div class="about" id="about">
    <div class="pic">
      <img src="../assets/illustration-your-users.svg" alt="illustration" data-aos="fade-in" data-aos-duration="1000">
    </div>
    <!-- <a href="#About">About</a> -->
    <div class="txt">
    <h2>About <span>Me</span></h2>
    <div class="grid">
      <div class="msgs">
        <p>
          I am Abdulrahman Badamasi, a.k.a (Jordan).<br/>
          I'm a Logical and result-driven Web Developer, dedicated to building and optimizing
          users-focused website for customers with various business objectives.
          Enthusiastic and eager to contribute to team success through hardwork, attention to details and excellent organizational skills.
          Motivated to learn, grow and excel in Software Engineering.
        </p>
      </div>
      <div>
        <h4> Educational background</h4> 
        <div class="educ">
          <p>
          An undergraduate in Electrical Engineering,  Ahmadu Bello Unviersity Zaria
          </p>
          <p>National Diploma in Electrical Engineering, federal polytechnic Bauchi</p>
        
        </div>
      
        <h4>
          Skills
        </h4>
        <div class="exp">
          <p>
            HTML
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"/></svg> -->
          </p>
          <p>
            CSS
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"/></svg> -->
          </p>
          <p>
            JS
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"/></svg> -->
          </p>
          <p>
            React
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"/></svg> -->
             </p>
          <p>
            Vue
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"/></svg> -->
          </p>
          <p>
            Vuex
          </p>
          <p>
            git
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"/></svg> -->
          </p>
          <p>
            Bootstrap
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.<path d="M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"/></svg> -->
          </p>
          <p>
          </p>
        </div>
      </div>
      <div class="exp1">
        <h4>
          Experience
        </h4>
       
        <div class="expp">
          <div class="ep">
            <p>
            08/2022 - 11/2022 <br>
            Abuja, Nigeria
          </p>
          <p>
            <b>Internship</b> <br><i> QT Solution Services</i>
          </p>
          </div>
          <ul>
            <li>I Interned with QTSS as a frontend Developer </li>
            <li>Analyze problem and work with team to develop solutions </li>
          </ul>
        </div>
        <div class="imgs">
          <img src="../assets/BadamasiAbdulRahman.png" alt="badamasi">
        </div>
      </div>
      </div>
    </div>
    <div class="exp2">
        <h4>
          Experience
        </h4>
        <div class="expp1">
          <div class="ep">
            <div class="div">
              <p>
            08/2022 - 11/2022 <br>
            Abuja, Nigeria
            </p>
            <p>
              <b>Internship</b> <br><i> QT Solution Services</i>
            </p>
          
            </div>
          <!-- <div class="ul"> -->
            <ul>
              <li>I Interned with QTSS as a frontend Developer </li>
              <li>Analyze problem and work with team to develop solutions </li>
            </ul>
          <!-- </div> -->
        </div>
        <div class="imgs">
          <img src="../assets/BadamasiAbdulRahman.png" alt="badamasi">
        </div>
        </div>
      </div>
  </div>
  </div>
</template>
 
<script>
export default {
    name:"Home",
    props: {
      abb: String
    },
}
</script>

<style>
     .about{
    position: relative;
    width: 100%;
    margin: 0;
    color: #178696;
    line-height: 30px;
    padding: 4.4em 20px;
    padding-bottom: 5em;
  }
  .txt > div{
    margin-bottom: 20px;
    letter-spacing: 0.7px;
  }
  .txt .educ, .txt .msgs{
    background: #11334d;
    /* background: #000109; */
    padding: 12px;
    border-radius: 10px;
  }
  .txt h4, .txt h2{
    color: #71dfd4;
    text-align: center;
    letter-spacing: 1px;
  }
  .txt h2 span{
    color: #178696;
  }
  .txt h4{
    margin-top: 20px;
  }
  .txt .exp{
    display: flex;
    border-radius: 10px;
    align-items: center;
    background: #11334d;
    flex-wrap: wrap;
    margin-bottom: 2em;
  }
  .txt .exp p{
    flex: 1;
    padding: 12px;
    /* background: #1e2238; */
  }
  .exp1{
    position: relative;
    min-height: 100vh;
  }
  .exp1 h4{
    text-align: center;
  }
  .exp1 .expp{
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: #11334d;
    border-radius: 10px;
    padding: 14px;
    margin-bottom: 20px;
  }
  .expp .ep{
    display: flex;
    gap: 20px;
  }
  .expp1 .ep{
    background: #11334d;
    border-radius: 10px;
    padding: 14px;
    /* margin-bottom: 20px; */
  }
  .exp1 ul{
    padding-left: 13px;
  }
  .exp1 .imgs{
    position: relative;
    width: 100%;
    height: 49.9vh
  }
  .exp1 .imgs img{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .pic{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 14px;
  }
  .pic img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
  }
  .me{
    color:hsl(192, 100%, 9%),
     hsl(207, 100%, 98%),  hsl(0, 100%, 63%), #4487f3
  }
  @media screen and (min-width: 768px) {
    .about{
    padding-top:5.9em ;
    }
    .grid{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 10px;
    }
    .msgs{
      margin-top: 30px;
    }
    .exp1 {
      grid-column: 1/3;
    }
   
    .exp1 .expp{
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
    .exp1 .expp .ep{
      grid-column: 1/4;
      margin: 0;
    }
    .exp1 .expp p:nth-child(1){
      grid-column: 1/2;
      flex: 1;
    }
    .exp1 .expp p:nth-child(2), ul{
      grid-column: 2/4;
      flex: 2;
    }
  } 
  @media screen and (min-width: 1100px) {
    .grid{
      display: unset;
      /* grid-template-columns: repeat(2, 1fr);
      column-gap: 10px; */
    }
    .about{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 30px;
      padding: 6.8em 40px;
    }
     .exp1{
      display: none;
    }
    .exp2{
      grid-column: 1/3;
    }
    .exp2 .expp1{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    .exp2 h4{
      color: #71dfd4;
      text-align: center;
      margin: 2em 0;
    }
    .exp2 .expp1 .ep{
      grid-column: 1/2;
      display: flex;
      flex-direction: column;
      /* padding-top: 3em; */
      /* width: 49vw; */
    }
    .exp2 .expp1 .imgs {
      position: relative;
      width: 100%;
      padding: 20px;
      /* grid-column: 2/3; */
      border-radius: 10px;
      overflow: hidden;
      height: 49vh;
    }
    .exp2 .expp1 .imgs img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .exp2 .expp1 .ep .div{
      display: flex;
      gap: 3em;
      /* justify-content: space-between; */
    }
 
    .exp2 .expp1 .ep ul{
      padding-left: 31%;    
    } 
  }



  @media screen and (max-width: 1100px) {
    .exp2{
      display: none;
      /* grid-column: 1/3; */
    }
  }
  @media screen and (max-width: 770px) {
    .pic{
    display: none;
    }
   
   
  }
</style>
